/**
 * The Validate button beside a part of the patient form's Clear (or remove) button: checks that part's details
 * with Medicare, DVA or the health fund. The answer shows under the part - see patientCoverResult.
 */
app.component("patientCoverValidate", {
	templateUrl: "app/src/js/components/patientCoverCheck/patientCoverValidate.html",
	controller: "patientCoverValidateController",
	bindings: {
		patient: "<",
		// The date of birth as the form holds it: { DD, MM, YYYY }.
		dateOfBirth: "<",
		// MEDICARE, DVA or POLICY.
		kind: "@",
		// The policy, for POLICY.
		policy: "<",
	},
});

app.controller("patientCoverValidateController", [
	"PatientCoverCheckService",
	function (PatientCoverCheckService) {
		const $ctrl = this;

		$ctrl.$onInit = function () {
			$ctrl.canValidate = PatientCoverCheckService.canValidate();
		};

		$ctrl.isOffered = function () {
			return $ctrl.canValidate && PatientCoverCheckService.hasDetails($ctrl.patient, $ctrl.kind, $ctrl.policy);
		};

		$ctrl.isChecking = function () {
			const state = PatientCoverCheckService.stateFor($ctrl.patient, $ctrl.kind, $ctrl.policy);
			return !!(state && state.checking);
		};

		// Stopped from reaching the policy heading, whose click opens and closes the policy.
		$ctrl.validate = function ($event) {
			if ($event) $event.stopPropagation();
			PatientCoverCheckService.validate($ctrl.patient, $ctrl.dateOfBirth, $ctrl.kind, $ctrl.policy);
		};
	},
]);
